export enum UserPreferenceType {
  // The notification wire identifiers follow the api's class paths (OLIO-3318 renamed the
  // record family; the legacy bare-'notification' identifier is fully retired — the api
  // rejects it and has emitted only slash-paths since the rename deployed).
  NOTIFICATION_CARE_COORDINATION = 'notification/care_coordination',
  NOTIFICATION_INBOUND_REFERRALS = 'notification/inbound_referrals',
  INSIGHTS_FILTER = 'insights_filter',
  PORTFOLIO_FILTER = 'portfolio_filter',
  DISCHARGE_CALENDAR_FILTER = 'discharge_calendar_filter',
}

export interface UserPreferenceOptions {
  id: string;
  clientId: string;
  type: UserPreferenceType;
  // Models inheriting from this class should define the shape of `value`
  value: Record<string, any>;
}

export function getDefaults(): UserPreferenceOptions {
  return {
    id: '',
    clientId: '',
    type: UserPreferenceType.PORTFOLIO_FILTER,
    value: {},
  };
}

export default class UserPreference {
  id: string;
  clientId: string;
  type: UserPreferenceType;
  // Models inherting from this class should define the shape of `value`
  value: Record<string, any>;

  constructor(options: Partial<UserPreferenceOptions> = {}) {
    const opts = { ...getDefaults(), ...options };

    this.id = opts.id;
    this.clientId = opts.clientId;
    this.type = opts.type;
    this.value = opts.value;
  }
}
